export interface RecordingDTO {
    id: number;
    userId: number,
    noteId: number,
    recordingDate: Date,
    status: string,
    meetingNotes: string
}

export interface RecordingWriteDTO {
    userId: number,
    noteId: number,
    recordingDate: Date,
    status: string,
    meetingNotes: string
}

export function createRecording(        
    userId: number,
    noteId: number,
    recordingDate: Date,
    status: string,
    meetingNotes: string

) {
    return {
        userId: userId, noteId: noteId, recordingDate: recordingDate, status: status, meetingNotes: meetingNotes}
}